import React from 'react';
import SectionHead from './SectionHead';
import { STACK } from '../data';
import { useLang } from '../LangContext';
import { useScramble } from '../hooks/useScramble';

function StackCell({ s }) {
  const [name, play] = useScramble(s.name);

  return (
    <div className="stack__cell tgt" onMouseEnter={play}>
      <div className="stack__num">{s.n}</div>
      <div>
        <div className="stack__name">{name}</div>
        <div className="stack__cat">{`// ${s.cat}`}</div>
      </div>
    </div>
  );
}

export default function Stack() {
  const { t } = useLang();

  return (
    <section className="s fullpage-section" id="stack">
      <div className="s__inner">
        <SectionHead label={t.stack.label} title={t.stack.title} />
        <div className="stack">
          {STACK.map((s) => (
            <StackCell s={s} key={s.n} />
          ))}
        </div>
      </div>
    </section>
  );
}
